import React from 'react'

const LanguageIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <g clip-path="url(#clip0_4412_12853)">
    <path d="M9.99935 18.3346C14.6017 18.3346 18.3327 14.6037 18.3327 10.0013C18.3327 5.39893 14.6017 1.66797 9.99935 1.66797C5.39698 1.66797 1.66602 5.39893 1.66602 10.0013C1.66602 14.6037 5.39698 18.3346 9.99935 18.3346Z" stroke="#06121C" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9.99935 1.66797C7.85954 3.91476 6.66602 6.89859 6.66602 10.0013C6.66602 13.104 7.85954 16.0878 9.99935 18.3346C12.1392 16.0878 13.3327 13.104 13.3327 10.0013C13.3327 6.89859 12.1392 3.91476 9.99935 1.66797Z" stroke="#06121C" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M1.66602 10H18.3327" stroke="#06121C" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_4412_12853">
      <rect width="20" height="20" fill="white"/>
    </clipPath>
  </defs>
</svg>
  )
}

export default LanguageIcon